export enum ExperimentResultsSelection {
  All = 'all',
  OnlyQAFailed = 'only_qa_failed',
  WithoutFeatures = 'without_feature_values',
  FeatureValues = 'only_feature_values',
}

export interface EncodedFiltersProps {
  experimentResultsSelection?: ExperimentResultsSelection;
}
